export enum DateRangeScope {
  Global = 'global',
  Reporting = 'reporting',
  Simulator = 'simulator',
  SimulatorRunner = 'simulator-runner',
  Assistant = 'assistant',
  DumpViewer = 'dump-viewer',
}
